"use client";

import { twMerge } from "tailwind-merge";

import { NormalText } from "@/components/text/NormalText";
import { SmallTitle } from "@/components/text/SmallTitle";
import { UserNoDates } from "@/types/types";
import { getSecondsLeft } from "@/utils/subscriptionLevels/time/getSecondsLeft";
import { getFormattedTimeLeft } from "@/utils/time/getFormattedTimeLeft";

export function TimeLeftCard({
  user,
  className,
}: {
  user: UserNoDates;
  className?: string;
}) {
  const secondsLeft = getSecondsLeft(user);

  let formattedTimeLeft: string;
  if (secondsLeft === null) {
    formattedTimeLeft = "Unlimited";
  } else {
    formattedTimeLeft = getFormattedTimeLeft(secondsLeft);
  }

  return (
    <div
      className={twMerge(
        "rounded-3xl bg-primaryLight px-4 py-2 shadow-sm ring-1 ring-inset ring-primary",
        className
      )}
    >
      <NormalText elementType="span" className="mb-2 block">
        Time left:
      </NormalText>
      <SmallTitle elementType="span" className="block break-words">
        {formattedTimeLeft}
      </SmallTitle>
    </div>
  );
}
